<div class="go-back">
	<a href="javascript:void(0);" (click)="onCancel()">
		<i class="fa fa-arrow-left"></i>
		<h6 class="text-uppercase">add comment</h6>
	</a>
</div>
<div *ngIf="this.orderDetailModel.id" class="wrapper add-comment">
	<div class="rule-info">
		<div class="rule-body">
			<div class="rule-title">
				<h5>{{rule.displayText}}</h5>
			</div>
			<div class="rule-badges">
				<span class="badge bg-secondary">{{rule.ruleSetDisplayText}}</span>
				<span class="badge bg-secondary" *ngIf="rule.category !== 'Unknown'">{{rule.category}}</span>
			</div>
		</div>
	</div>
	<div class="add-comment-form input-form">
		<div *ngIf="isPhotoReview">
			<label for="link">
				<input type="checkbox"
					   name="link" id="link"
					   [(ngModel)]="linkToPhoto"
					   [disabled]="saving">
				<span>Link this comment to the photo that is currently displayed.</span>
			</label>
		</div>
		<div>
			<textarea name="resolution" rows="5"
					  [(ngModel)]="comment"
					  (keyup)="onCommentKeyUp()"
					  [disabled]="saving">
			</textarea>
		</div>
		<div class="text-right action-button">
			<p-button
				[disabled]="!comment || !comment.length || saving || !lockedBy.byTheUser"
				(onClick)="addComment()">
				<i class="pi pi-check" ></i>
				{{saving ? 'saving..' : 'post' }}
			</p-button>
		</div>
	</div>
</div>
